export const CLASS_Nursery_SUBJECTS = [
  { name: "Hindi", code: "N101" ,type: "OTHER"},
  { name: "English", code: "N102" ,type:"OTHER"},
  { name: "Maths", code: "N103" ,type:"OTHER"},
];

export const CLASS_LKG_SUBJECTS = [
  { name: "Hindi", code: "L101" ,type:"OTHER"},
  { name: "English", code: "L102" ,type:"OTHER"},
  { name: "Maths", code: "L103" ,type:"OTHER"},
];

export const CLASS_UKG_SUBJECTS = [
  { name: "Hindi", code: "U101" ,type:"OTHER"},
  { name: "English", code: "U102" ,type:"OTHER"},
  { name: "Maths", code: "U103" ,type:"OTHER"},
];

// Class 1st to 8th Subjects
export const CLASS_1_TO_5_SUBJECTS = [
  { name: "Hindi", code: "HIN101" ,type:"OTHER"},
  { name: "English", code: "ENG102" ,type:"OTHER"},
  { name: "Urdu", code: "URD103" ,type:"OTHER"},
  { name: "Marathi", code: "MAR104" ,type:"OTHER"},
  { name: "Maths", code: "MAT105" ,type:"OTHER"},
  { name: "Music", code: "MUS106" ,type:"OTHER"},
  { name: "Environmental Studies", code: "ENV107" ,type:"OTHER"},
  // Extra Subject options
  { name: "Sanskrit", code: "SAN108" ,type:"OTHER"},
  { name: "Punjabi", code: "PUN109" ,type:"OTHER"},
  { name: "Odia", code: "ODI110" ,type:"OTHER"},
  { name: "Gujarati", code: "GUJ111" ,type:"OTHER"},
  { name: "Painting", code: "PAI112" ,type:"OTHER"},
];

export const CLASS_6_TO_8_SUBJECTS = [
  { name: "Hindi", code: "HIN201" ,type:"OTHER"},
  { name: "English", code: "ENG202" ,type:"OTHER"},
  { name: "Urdu", code: "URD203" ,type:"OTHER"},
  { name: "Marathi", code: "MAR204" ,type:"OTHER"},
  // Third Language options (Class 6–8)
  { name: "Sanskrit", code: "SAN205" ,type:"OTHER"},
  { name: "Punjabi", code: "PUN206" ,type:"OTHER"},
  { name: "Gujarati", code: "GUJ207" ,type:"OTHER"},
  { name: "Odia", code: "ODI208" ,type:"OTHER"},
  { name: "Painting", code: "PAI209" ,type:"OTHER"},
  { name: "Maths", code: "MAT210" ,type:"OTHER"},
  { name: "Music", code: "MUS211" ,type:"OTHER"},
  { name: "Science", code: "SCI212" ,type:"OTHER"},
  { name: "Social Science", code: "SOC213" ,type:"OTHER"},
];

export const TENTH_CLASS_SUBJECTS = [
  { name: "Maths (Standard)", code: "100" ,type:"OTHER"},
  { name: "Maths (Basic)", code: "101" ,type:"OTHER"},
  { name: "Painting", code: "162" ,type:"VOCATIONAL"},
  { name: "Gayan Vadan", code: "163" ,type:"VOCATIONAL"},
  { name: "Tabla Pakhawaj", code: "164" ,type:"VOCATIONAL"},
  { name: "Computer", code: "165" ,type:"VOCATIONAL"},
  { name: "Science", code: "200" ,type:"OTHER"},
  { name: "Social Science", code: "300" ,type:"OTHER"},
  { name: "Hindi", code: "401" ,type:"OTHER"},
  { name: "English", code: "411" ,type:"OTHER"},
  { name: "Marathi", code: "502" ,type:"OTHER"},
  { name: "Gujrati", code: "504" ,type:"OTHER"},
  { name: "Punjabi", code: "507" ,type:"OTHER"},
  { name: "Urdu", code: "508" ,type:"OTHER"},
  { name: "Sindhi", code: "509" ,type:"OTHER"},
  { name: "Sanskrit", code: "512" ,type:"OTHER"},
  { name: "IT-ITES", code: "863" ,type:"VOCATIONAL"},
  { name: "Electronics & Hardware", code: "878" ,type:"VOCATIONAL"}
];

// Class 11th and 12th Subjects organized by Groups/Streams
export const ELEVENTH_TWELFTH_CLASS_SUBJECTS_GROUPED = [
  {
    groupName: "LANGUAGE",
    groupCode: null,
    description: "Any Two of the following",
    subjects: [
      { name: "Hindi", code: "051" ,type:"OTHER"},
      { name: "English", code: "052" ,type:"OTHER"},
      { name: "Sanskrit", code: "053" ,type:"OTHER"},
      { name: "Marathi", code: "054" ,type:"OTHER"},
      { name: "Urdu", code: "055" ,type:"OTHER"},
    ],
  },
  {
    groupName: "HUMANITIES GROUP",
    groupCode: "1",
    description: "GROUP CODE - 1",
    hasSubgroups: true,
    subgroups: [
      {
        subgroupName: "A",
        description: "At least two or three subjects shall be offered from the following",
        subjects: [
          { name: "History", code: "110" ,type:"OTHER"},
          { name: "Geography", code: "120" ,type:"PRACTICAL"},
          { name: "Political Science", code: "130" ,type:"OTHER"},
          { name: "Economics", code: "140" ,type:"OTHER"},
        ],
      },
      {
        subgroupName: "B",
        description: "Any one of the following if only two subjects offered from part A",
        subjects: [
          { name: "Mathematics", code: "150" ,type:"OTHER"},
          { name: "Informatic Practices", code: "151" ,type:"PRACTICAL"},
          { name: "Drawing & Designing", code: "162" ,type:"OTHER"},
          { name: "Gayan Vadan", code: "163" ,type:"OTHER"},
          { name: "Tabla Pakhawaj", code: "164" ,type:"OTHER"},
          { name: "Agriculture", code: "165" ,type:"PRACTICAL"},
          { name: "Sociology", code: "166" ,type:"OTHER"},
          { name: "Psychology", code: "167" ,type:"PRACTICAL"},
          { name: "Home Science (Anat. Phys. & Hygins)", code: "168" ,type:"PRACTICAL"},
        ],
      },
    ],
    // Keep subjects array for backward compatibility (flattened from subgroups)
    subjects: [
      { name: "History", code: "110" ,type:"OTHER"},
      { name: "Geography", code: "120" ,type:"PRACTICAL"},
      { name: "Political Science", code: "130" ,type:"OTHER"},
      { name: "Economics", code: "140" ,type:"OTHER"},
      { name: "Mathematics", code: "150" ,type:"OTHER"},
      { name: "Informatic Practices", code: "151" ,type:"PRACTICAL"},
      { name: "Drawing & Designing", code: "162" ,type:"OTHER"},
      { name: "Gayan Vadan", code: "163" ,type:"OTHER"},
      { name: "Tabla Pakhawaj", code: "164" ,type:"OTHER"},
      { name: "Agriculture", code: "165" ,type:"PRACTICAL"},
      { name: "Sociology", code: "166" ,type:"OTHER"},
      { name: "Psychology", code: "167" ,type:"PRACTICAL"},
      { name: "Home Science (Anat. Phys. & Hygins)", code: "168" ,type:"PRACTICAL"},
    ],
  },
  {
    groupName: "SCIENCE MATHS GROUP",
    groupCode: "2",
    description: "GROUP CODE - 2",
    subjects: [
      { name: "Physics", code: "210" ,type:"PRACTICAL"},
      { name: "Chemistry", code: "220" ,type:"PRACTICAL"},
      { name: "Mathematics", code: "150" ,type:"OTHER"},
    ],
  },
  {
    groupName: "COMMERCE GROUP",
    groupCode: "3",
    description: "GROUP CODE - 3",
    hasSubgroups: true,
    subgroups: [
      {
        subgroupName: "A",
        subjects: [
          { name: "Business Studies", code: "310" ,type:"OTHER"},
          { name: "Book Keeping & Accountancy", code: "320" ,type:"OTHER"}
        ],
      },
      {
        subgroupName: "B",
        description: "Any one of the following",
        subjects: [
          { name: "Mathematics", code: "150" ,type:"OTHER"},
          { name: "Informatic Practices", code: "151" ,type:"PRACTICAL"},
          { name: "Economics", code: "140" ,type:"OTHER"},
        ],
      },
    ],
    subjects: [
      { name: "Business Studies", code: "310" ,type:"OTHER"},
      { name: "Book Keeping & Accountancy", code: "320" ,type:"OTHER"},
      { name: "Mathematics", code: "150" ,type:"OTHER"},
      { name: "Informatic Practices", code: "151" ,type:"PRACTICAL"},
      { name: "Economics", code: "140" ,type:"OTHER"},
    ],
  },
  {
    groupName: "AGRICULTURE GROUP",
    groupCode: "4",
    description: "GROUP CODE - 4",
    subjects: [
      { name: "Element of Science & Maths Useful for Agriculture", code: "410" ,type:"PRACTICAL"},
      { name: "Crop Production & Horticulture", code: "420" ,type:"PRACTICAL"},
      { name: "Animal Hus. Milk trade, Poultry farming & fishery", code: "430" ,type:"PRACTICAL"},
    ],
  },
  {
    groupName: "FINE ART GROUP",
    groupCode: "5",
    description: "GROUP CODE - 5",
    subjects: [
      { name: "Drawing & Painting", code: "510" ,type:"OTHER"},
      { name: "Still life & Design", code: "520" ,type:"OTHER"},
      { name: "History of Indian Art & World Art", code: "530" ,type:"OTHER"},
    ],
  },
  {
    groupName: "HOME SCIENCE GROUP",
    groupCode: "6",
    description: "GROUP CODE - 6",
    subjects: [
      { name: "Home Management Nutrition & Textile", code: "610" ,type:"PRACTICAL"},
      { name: "Anatomy physiology & Health", code: "620" ,type:"PRACTICAL"},
      { name: "Elements of Science", code: "631" ,type:"PRACTICAL"},
    ],
  },
  {
    groupName: "SCIENCE BIO. GROUP",
    groupCode: "7",
    description: "GROUP CODE - 7",
    subjects: [
      { name: "Physics", code: "210" ,type:"PRACTICAL"},
      { name: "Chemistry", code: "220" ,type:"PRACTICAL"},
      { name: "Biology", code: "231" ,type:"PRACTICAL"},
    ],
  },
  {
    groupName: "LANGUAGE GROUP",
    groupCode: "8",
    description: "GROUP CODE - 8",
    hasSubgroups: true,
    subgroups: [
      {
        subgroupName: "A",
        description: "Any one language not already offered as language",
        subjects: [
          { name: "Hindi", code: "051" ,type:"OTHER"},
          { name: "English", code: "052" ,type:"OTHER"},
          { name: "Sanskrit", code: "053" ,type:"OTHER"},
          { name: "Urdu", code: "055" ,type:"OTHER"},
        ],
      },
      {
        subgroupName: "B",
        description: "Any two from the following",
        subjects: [
          { name: "History", code: "110" ,type:"OTHER"},
          { name: "Geography", code: "120" ,type:"PRACTICAL"},
          { name: "Political Science", code: "130" ,type:"OTHER"},
          { name: "Economics", code: "140" ,type:"OTHER"},
          { name: "Sociology", code: "166" ,type:"OTHER"},
        ],
      },
    ],
    // Keep subjects array for backward compatibility (flattened from subgroups)
    subjects: [
      { name: "Hindi", code: "051" ,type:"OTHER"},
      { name: "English", code: "052" ,type:"OTHER"},
      { name: "Sanskrit", code: "053" ,type:"OTHER"},
      { name: "Urdu", code: "055" ,type:"OTHER"},
      { name: "History", code: "110" ,type:"OTHER"},
      { name: "Geography", code: "120" ,type:"PRACTICAL"},
      { name: "Political Science", code: "130" ,type:"OTHER"},
      { name: "Economics", code: "140" ,type:"OTHER"},
      { name: "Sociology", code: "166" ,type:"OTHER"},
    ],
  },
  {
    groupName: "ADDITIONAL SUBJECT (OPTIONAL)",
    groupCode: null,
    description: "Any one subject not already offered",
    subjects: [
      { name: "Book Keeping & Accountancy", code: "820" ,type:"OTHER"},
      { name: "Biology", code: "831" ,type:"OTHER"},
      { name: "Biotechnology", code: "832" ,type:"OTHER"},
      { name: "Physical Education", code: "833" ,type:"OTHER"},
      { name: "Mathematics", code: "850" ,type:"OTHER"},
      { name: "Informatic Practices", code: "851" ,type:"PRACTICAL"},
      { name: "Indian Music", code: "861" ,type:"OTHER"},
      { name: "Drawing & Designing", code: "862" ,type:"OTHER"},
      { name: "Gayan Vadan", code: "863" ,type:"OTHER"},
      { name: "Tabla Pakhawaj", code: "864" ,type:"OTHER"},
    ],
  },
  {
    groupName: "NSQF SUBJECT (OPTIONAL)",
    groupCode: null,
    description: "NSQF Vocational Subjects",
    subjects: [
      { name: "BEAUTY & WELLNESS", code: "965" ,type:"VOCATIONAL"},
      { name: "RETAIL", code: "970" ,type:"VOCATIONAL"},
      { name: "HEALTH CARE", code: "972" ,type:"VOCATIONAL"},
      { name: "AGRICULTURE (FLORICULTURIST)", code: "973" ,type:"VOCATIONAL"},
      { name: "PLUMBER", code: "974" ,type:"VOCATIONAL"},
      { name: "I.T. & ITES", code: "975" ,type:"VOCATIONAL"},
      { name: "ELECTRTONICS AND HARDWARE (ASSISTANT INSTALLATION TECHNICIAN)", code: "976" ,type:"VOCATIONAL"},
      { name: "AGRICULTURE (MICRO IRRIGATION TECHNICIAN)", code: "977" ,type:"VOCATIONAL"},
      { name: "MEDIA AND ENTERTAINMENT", code: "978" ,type:"VOCATIONAL"},
      { name: "ELECTRONICS & HARDWARE (DRONE SERVICE TECHNICIAN)", code: "979" ,type:"VOCATIONAL"},
      { name: "ELECTRONICS & HARDWARE (SOLAR PANEL INSTALLATION TECHNICIAN)", code: "980" ,type:"VOCATIONAL"},
      { name: "PRIVATE SECURITY", code: "981" ,type:"VOCATIONAL"},
      { name: "BANKING FINANCIAL SERVICES & INSURANCE (BFSI)", code: "982" ,type:"VOCATIONAL"},
      { name: "APPARELS MADE UPS AND HOME FURNISHING", code: "983" ,type:"VOCATIONAL"},
      { name: "TOURISM & HOSPITALITY", code: "985" ,type:"VOCATIONAL"},
      { name: "AUTOMOTIVE", code: "986" ,type:"VOCATIONAL"},
      { name: "AI (ARTIFICIAL INTELEGENCE)", code: "987" ,type:"VOCATIONAL"},
    ],
  },
];

// Flat list of all Class 11th and 12th subjects for easy lookup (backward compatibility)
export const ELEVENTH_TWELFTH_CLASS_SUBJECTS = ELEVENTH_TWELFTH_CLASS_SUBJECTS_GROUPED.flatMap(
  (group) => group.subjects.map((subject) => ({ ...subject, group: group.groupName, groupCode: group.groupCode }))
);

// Export alias for backward compatibility
export const SUBJECT_OPTIONS = TENTH_CLASS_SUBJECTS;